export const ko = {
  common: {
    loading: '로딩 중...',
    error: '오류가 발생했습니다',
    retry: '재시도',
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    confirm: '확인',
    back: '뒤로',
    close: '닫기',
    search: '검색',
    noData: '데이터 없음',
  },
  tabs: {
    home: '홈',
    settings: '설정',
    profile: '프로필',
  },
  settings: {
    title: '설정',
    theme: '테마',
    themeLight: '라이트',
    themeDark: '다크',
    themeSystem: '시스템',
    language: '언어',
    version: '버전',
    about: '소개',
  },
  home: {
    title: '홈',
    welcome: '환영합니다',
    description: '기능을 편집하여 시작하세요.',
  },
  admin: {
    nav: {
      dashboard: '대시보드',
      samples: '샘플',
      training: '트레이닝',
      curriculum: '커리큘럼',
      testers: '테스터',
      modelQuality: '모델 품질',
      settings: '설정',
      menu: '메뉴',
      collapse: '접기',
    },
    header: { title: '관리자 패널' },
    reviewIo: {
      importDone: '검수 파일을 가져왔습니다',
      importError: '가져오기 실패 — 올바른 검수 JSON인지 확인하세요',
    },
    training: {
      title: '트레이닝',
      detailTitle: '노래 상세',
      subtitle: '연습용 노래를 등록하고 음정표를 생성·편집·저장합니다.',
      register: '노래 등록',
      exportList: '목록 내보내기',
      empty: '등록된 노래가 없습니다',
      emptyHint: '노래를 등록해 음정표 작업을 시작하세요.',
      loading: '불러오는 중...',
      notFound: '노래를 찾을 수 없습니다.',
      table: {
        title: '제목',
        artist: '아티스트',
        key: '키',
        bpm: 'BPM',
        duration: '길이',
        updated: '수정일',
      },
      form: {
        title: '제목',
        titlePlaceholder: '노래 제목',
        artist: '아티스트',
        key: '키',
        bpm: 'BPM',
        tags: '태그',
        tagsPlaceholder: '쉼표로 구분',
        notes: '메모',
        uploadAudio: '오디오 업로드',
        cancel: '취소',
        create: '등록',
      },
      detail: {
        metaTitle: '노래 정보',
        audioTitle: '오디오',
        chartTitle: '음정표',
        editorHint:
          '빈 곳을 클릭해 음을 추가하고, 드래그로 이동·길이조절, 선택 후 방향키로 이동(Shift+좌우=길이)·Delete로 삭제합니다. 음영 행은 키의 스케일, 회색 곡선은 엔진이 추출한 실제 피치입니다.',
        generate: '오디오에서 생성',
        generating: '생성 중...',
        import: '불러오기',
        save: '디스크에 저장',
        saveDownload: '내보내기(다운로드)',
        delete: '노래 삭제',
      },
    },
    dashboard: {
      title: '대시보드',
      subtitle: '검증 백로그에 대한 모델 QA 개요입니다.',
      greeting: '{{name}}님, 안녕하세요',
      todayOverview: '샘플과 세션에 대한 엔진 검증 현황입니다.',
      stats: {
        pending: '검증 대기',
        pendingHint: '샘플 {{samples}} · 세션 {{sessions}}',
        reviewed: '검수 완료',
        coverage: '커버리지 {{percent}}%',
        agreement: '엔진 일치율',
        agreementHint: '판정 {{count}}건',
        disagreements: '불일치',
        disagreementsHint: '엔진 오류 플래그',
      },
      disagreements: {
        title: '최근 불일치',
        empty: '아직 엔진-사람 간 불일치가 없습니다.',
        sample: '샘플',
        session: '세션',
      },
      coverage: {
        title: '커버리지',
        samples: '샘플 검수',
        sessions: '세션 검수',
        techniques: '창법 커버리지',
        testers: '테스터 커버리지',
      },
    },
    settings: {
      title: '설정',
      subtitle: '검수자 정보와 엔진 버전을 관리합니다.',
      reviewer: {
        title: '검수자',
        nameLabel: '이름',
        emailLabel: '이메일',
        roleLabel: '역할',
        save: '변경사항 저장',
      },
      engine: {
        title: '엔진',
        versionLabel: '엔진 버전',
        versionHint: '새 검증에 기록되는 버전 라벨입니다.',
        save: '변경사항 저장',
      },
      toast: {
        saved: '설정이 저장되었습니다',
      },
    },
    samples: {
      title: '샘플 검수',
      detailTitle: '샘플 상세',
      subtitle: '데이터셋 큐레이션을 위해 음성 샘플을 탐색·재생·검수합니다.',
      search: '파일명으로 검색...',
      count: '샘플 {{count}}개',
      resetFilters: '필터 초기화',
      startReview: '검수 시작',
      allReviewed: '검수 완료',
      verdict: {
        all: '전체',
        unreviewed: '미검수',
        engine_ok: '엔진 정상',
        engine_off: '엔진 오류',
        recapture: '재녹음',
      },
      metric: {
        pitchAccuracy: '음정 정확도',
        pitchStability: '안정성',
        sustain: '호흡 지속',
        vibrato: '비브라토',
        resonance: '공명',
        singersFormant: '싱어즈 포먼트',
      },
      metricDesc: {
        pitchAccuracy: '가장 가까운 음정과의 평균 오차 {{cents}} cents',
        pitchStability: '피치 흔들림(표준편차) {{cents}} cents',
        sustain: '안정 발성 약 {{sec}}초 지속',
        vibrato: '음정의 규칙적 떨림 정도',
        resonance: '배음 대비 잡음비(HNR) 기반 공명',
        singersFormant: '2.8~3.4kHz 고배음 에너지(성악적 울림)',
      },
      filter: {
        allExercises: '전체 연습',
        allTechniques: '전체 창법',
      },
      testerLevel: {
        expert: '전문가',
        amateur: '아마추어',
      },
      gender: {
        male: '남성',
        female: '여성',
      },
      exercise: {
        arpeggios: '아르페지오',
        scales: '스케일',
        long_tones: '롱톤',
        excerpts: '발췌',
      },
      technique: {
        belt: '벨팅',
        breathy: '브레시',
        vibrato: '비브라토',
        vocal_fry: '보컬 프라이',
        lip_trill: '립 트릴',
        straight: '스트레이트',
        slow_forte: '슬로우 포르테',
        slow_piano: '슬로우 피아노',
        fast_forte: '패스트 포르테',
        fast_piano: '패스트 피아노',
        messa: '메사 디 보체',
        trill: '트릴',
        trillo: '트릴로',
        forte: '포르테',
        inhaled: '들숨',
        pp: '피아니시모',
        spoken: '말하기',
      },
      table: {
        file: '파일',
        tester: '테스터',
        exercise: '연습',
        technique: '창법',
        vowel: '모음',
        verdict: '판정',
      },
      vowelNone: '—',
      empty: '샘플이 없습니다',
      emptyHint: '검색어 또는 필터를 조정해 보세요.',
      trainingExport: {
        json: '학습쌍 JSON',
        csv: '학습쌍 CSV',
        empty: '내보낼 학습쌍이 없습니다 — 검수 완료된 샘플이 필요합니다',
        done: '학습쌍 {{count}}건을 내보냈습니다',
      },
      detail: {
        back: '음성 데이터 검수',
        play: '재생',
        pause: '일시정지',
        spectrogram: '스펙트로그램',
        speed: '재생 속도',
        zoomIn: '확대',
        zoomOut: '축소',
        noAudio: '오디오 샘플이 없습니다',
        metadata: '메타데이터',
        fileName: '파일명',
        batch: '배치',
        reviewPanel: '검수',
        verdictLabel: '판정',
        tagsLabel: '태그',
        tagsPlaceholder: '태그 입력 후 Enter (예: 쥐어짜는, 울림좋음)',
        noteLabel: '검수자 노트',
        notePlaceholder: '이 샘플에 대한 노트를 입력하세요...',
        save: '검수 저장',
        reviewedBy: '검수자',
        reviewedAt: '검수일',
        engineOutput: '엔진 분석 결과',
        analyze: '분석',
        analyzeRegion: '구간 분석',
        reanalyze: '재분석',
        analyzing: '분석 중…',
        region: '구간',
        clearRegion: '구간 해제',
        selectHint: '파형을 드래그해 분석할 구간을 선택하세요',
        notAnalyzed: '아직 분석되지 않았습니다',
        agree: '동의',
        agreeAll: '전체 동의',
        off: '오류',
        corrected: '수정값',
        metricNote: '지표 메모',
        sfVerdict: '싱어즈 포먼트 판정',
        sfEngineSays: '엔진 판정: {{call}}',
        sfMismatch: '엔진과 불일치',
        present: '있음',
        absent: '없음',
        pitch: '음정',
        centroid: '중심 주파수',
        hnr: 'HNR',
        singersFormant: '싱어즈 포먼트',
        note: '음이름',
        sfBandHint: '싱어즈 포먼트 = 2.8–3.4kHz 대역 에너지 비율',
        contourTitle: '음정 편차 (cents · 0 = 정확)',
        f0: 'f0',
        jitter: 'Jitter',
        shimmer: 'Shimmer',
        sfPeak: 'SF 피크',
        sfRel: 'SF 상대레벨',
        spectrumTitle: '평균 스펙트럼',
        formantsTitle: '포먼트 측정값',
        harmonicsTitle: '배음 (H1 대비 dB)',
        normal: '정상',
        high: '높음',
        low: '낮음',
        unmeasured: '미측정',
        formant: {
          f1: '개구도',
          f2: '혀 위치',
          f3: '공명 / 밝기',
          f4: '가수 포먼트',
        },
        reviewMetrics: '검수 항목',
        unsavedWarning:
          '저장하지 않은 변경 사항이 있습니다. 이 화면을 떠나시겠습니까?',
        reviewProgress: '검수 {{done}} / {{total}}',
        prevSample: '이전 샘플 (K)',
        nextSample: '다음 샘플 (J)',
        kbdHint: '1·2·3 판정 · S 저장+다음 · J/K 이동 · U 미검수로 · ? 도움말',
        medianDev: '중앙 편차 ±{{cents}}¢',
        shortcuts: {
          title: '키보드 단축키',
          verdict: '판정 (정상 / 오류 / 재녹음)',
          save: '저장 후 다음 미검수로',
          next: '다음 샘플',
          prev: '이전 샘플',
          unreviewed: '다음 미검수',
          play: '재생 / 정지',
          seek: '3초 뒤로 / 앞으로',
          close: '닫기',
        },
      },
      grade: {
        master: '최상 (Master)',
        excel: '우수 (Excel)',
        good: '안정 (Good)',
        clean: '양호 (Clean)',
        normal: '보통 (Normal)',
        caution: '주의 (Caution)',
        crisis: '위험 (Crisis)',
      },
      toast: {
        saved: '검수가 저장되었습니다',
      },
    },
    curriculum: {
      title: '커리큘럼 검수',
      detailTitle: '커리큘럼 검수',
      intro: '플레이어 앱 전에 워밍업 훈련의 음정·오디오·메타를 검수합니다.',
      loading: '불러오는 중…',
      loadError: '커리큘럼을 불러오지 못했습니다',
      notFound: '항목을 찾을 수 없습니다.',
      backToList: '목록으로',
      programs: '프로그램',
      exercises: '훈련',
      stepsN: '{{n}}단계',
      code: '코드',
      name: '이름',
      level: '레벨',
      range: '음역',
      status: '검수',
      reviewed: '검수완료',
      pending: '미검수',
      stale: '내용 변경됨',
      staleItem: '변경됨',
      staleN: '재확인 필요 {{n}}',
      errorsN: '오류 {{n}}',
      pitch: '음정',
      pitchHint:
        '멜로디와 MR을 같은 위치에서 번갈아 들어 "MR이 악보대로 울리는가"를 판정합니다. 눈금을 클릭하면 그 지점으로 이동합니다.',
      contourNote:
        '회색 곡선은 MR에서 추출한 피치입니다 — 다성 피아노에서는 부정확할 수 있는 보조 지표입니다.',
      editorHint:
        '빈 곳을 클릭해 음을 추가하고, 드래그로 이동·길이조절, 선택 후 방향키로 이동(Shift+좌우=길이)·Delete로 삭제합니다.',
      play: '재생',
      stop: '정지',
      sourceMelody: '멜로디',
      sourceMr: 'MR',
      melodyEdited: '수정됨',
      saveMelody: '멜로디 디스크 저장',
      saveMelodyDownload: '멜로디 내보내기',
      revertMelody: '원본 되돌리기',
      noNotes: '음이 하나도 없습니다 — 저장할 수 없습니다',
      analyzingMr: 'MR 분석 중…',
      audio: '오디오',
      mr: 'MR 반주',
      audioMissing: '오디오 없음',
      guide: '가이드 음성',
      meta: '메타',
      importReview: '검수 가져오기',
      exportReview: '검수 내보내기',
      saveReview: '검수 디스크 저장',
      saveReviewDownload: '검수 저장(다운로드)',
      confirmImport:
        '검수 {{n}}건을 가져옵니다. 같은 항목의 현재 검수는 덮어씁니다. 계속할까요?',
      indexEdited: '커리큘럼에 저장하지 않은 변경이 있습니다',
      saveIndex: '변경사항 디스크 저장',
      saveIndexDownload: '변경사항 내보내기',
      revertIndex: '변경 취소',
      newProgram: '새 프로그램',
      untitledProgram: '이름 없는 프로그램',
      programName: '프로그램 이름',
      programDesc: '설명',
      deleteProgram: '프로그램 삭제',
      confirmDeleteProgram: '이 프로그램을 삭제할까요?',
      addStep: '스텝 추가',
      stepExercise: '훈련',
      stepTime: '시간',
      stepPurpose: '목적',
      stepUp: '위로',
      stepDown: '아래로',
      stepRemove: '스텝 삭제',
      mrSpec: 'MR 스펙 — 멜로디 생성기',
      specMatches: '현재 멜로디와 일치',
      specDiffers: '현재 멜로디와 불일치',
      specSummary: '노트 {{notes}}개 · {{range}}',
      specInvalid: '생성 불가 — 패턴/키를 확인하세요',
      applyGenerated: '생성 멜로디로 교체',
      mrAudioStale:
        'MR 스펙을 바꿨습니다. 기존 MR 오디오는 예전 스펙으로 구운 것이라, 다시 구울 때까지 멜로디↔MR 청취로만 확인할 수 있습니다.',
      totalTime: '총 시간',
      minutesN: '{{n}}분',
      bookend: '웜업·쿨다운 포함',
      stepsResolve: '스텝 해석',
      steps: '스텝',
      missingExercise: '없는 훈련',
      reviewItems: '검수 항목',
      agree: '동의',
      error: '오류',
      itemNote: '메모',
      allAgreed: '전체 동의됨',
      progress: '{{done}}/{{total}}',
      clip: { intro: '소개', how: '방법', cue: '큐' },
      field: {
        name: '이름',
        en: '영문명',
        level: '레벨',
        vowels: '모음',
        difficulty: '난이도',
        minutes: '시간',
        key: '키(루트음)',
        effect: '효과',
        warn: '안전 경고',
        pattern: '패턴',
        bpm: 'BPM',
        repeats: '반복',
        span: '음역(반음)',
        dur: '음 길이(초)',
      },
      item: {
        melody: '멜로디 정확도',
        range: '음역 적정',
        mrMatch: 'MR ↔ 멜로디 일치',
        guideIntro: '가이드: 소개',
        guideHow: '가이드: 방법',
        guideCue: '가이드: 큐',
        audioMeta: '오디오 품질',
        metaFields: '메타 필드',
        steps: '스텝 구성',
        duration: '총 시간',
        bookend: '웜업·쿨다운',
        safety: '안전 원칙',
      },
    },
    testers: {
      title: '테스터',
      detailTitle: '테스터 상세',
      subtitle:
        '테스터를 탐색하고 진단 세션마다 분석 엔진의 결과를 검증합니다.',
      search: '이름 또는 핸들로 검색...',
      count: '테스터 {{count}}명',
      resetFilters: '필터 초기화',
      empty: '테스터가 없습니다',
      emptyHint: '검색어 또는 필터를 조정해 보세요.',
      level: {
        all: '전체',
        expert: '전문가',
        amateur: '아마추어',
      },
      gender: {
        all: '성별 전체',
        male: '남성',
        female: '여성',
      },
      filter: {
        allGenders: '성별 전체',
      },
      table: {
        tester: '테스터',
        level: '등급',
        gender: '성별',
        sessions: '세션',
        joined: '가입일',
      },
      verdict: {
        all: '전체',
        unreviewed: '미검수',
        engine_ok: '엔진 정상',
        engine_off: '엔진 오류',
        recapture: '재녹음',
      },
      session: {
        title: '세션',
        empty: '이 테스터의 세션이 아직 없습니다.',
      },
      clip: {
        title: '녹음',
        low: '저음',
        high: '고음',
        sustain: '지속음',
      },
      report: {
        title: '엔진 분석 결과',
        clipsSuffix: '개 클립',
        vocalIndex: '보컬 인덱스',
        range: '음역대',
        fach: '성종(Fach)',
        vocalAge: '보컬 에이지',
        notAnalyzed: '아직 분석되지 않았습니다',
        analyze: '세션 분석',
        reanalyze: '재분석',
        analyzing: '분석 중…',
        agree: '동의',
        off: '오류',
        corrected: '수정값',
        placement: {
          velum: '연구개(공명)',
          fold: '성대(긴장)',
          tongue: '혀(먹먹함)',
          resonance: '공명 점수',
          warn: '경고',
          ok: '정상',
        },
      },
      detail: {
        back: '테스터',
        reviewPanel: '검수',
        verdictLabel: '판정',
        tagsLabel: '태그',
        tagsPlaceholder: '태그 입력 후 Enter (예: 쥐어짜는, 울림좋음)',
        noteLabel: '검수자 노트',
        notePlaceholder: '이 세션에 대한 노트를 입력하세요...',
        save: '검수 저장',
        reviewedBy: '검수자',
        reviewedAt: '검수일',
        unsavedWarning:
          '저장하지 않은 변경 사항이 있습니다. 이 화면을 떠나시겠습니까?',
      },
      toast: {
        saved: '검수가 저장되었습니다',
      },
    },
    labelHistory: {
      title: '라벨 이력',
      empty: '아직 저장된 검수 이력이 없습니다.',
      flags: '플래그 {{count}}개',
    },
    modelQuality: {
      title: '모델 품질',
      subtitle: '엔진-사람 일치율과 데이터셋 커버리지입니다.',
      stats: {
        agreement: '일치율',
        agreementHint: '판정 {{count}}개 항목 기준',
        collectingHint: '판정 {{count}}개 — 신뢰도 검증 중',
        flags: '판정 항목',
        metrics: '추적 지표 {{count}}개',
        corrections: '보정',
        correctionsHint: '검수자가 보정한 항목',
      },
      reliability: {
        collecting: '검증 중',
        insufficient: '신뢰도 부족',
        detail: '{{n}}건 · 평가자 {{raters}}명 · κ {{kappa}}',
      },
      metrics: {
        title: '지표별 편차',
        agreement: '일치율',
        corrections: '보정',
        avgDelta: '평균 Δ',
      },
      coverage: {
        title: '커버리지 — 창법 × 성별',
        technique: '창법',
        male: '남성',
        female: '여성',
        total: '합계',
      },
    },
  },
  landing: {
    nav: {
      goldPrice: '금시세',
      about: '사업소개',
      reservation: '방문예약',
      report: '태범리포트',
    },
    hero: {
      badge: '현물 자산 전문 기업',
      title: '실물 자산 거래의 기준을',
      titleHighlight: '다시 세웁니다.',
      subtitle:
        '태범귀금속은 정련 기반의 감정 기술과 실시간 시세 데이터를 바탕으로 귀금속과 산업 원자재의 가치를 더 투명하게 연결합니다.',
      keyMessage: '직접 매입하고, 직접 공급합니다.',
      ctaPrimary: '실시간 시세 확인',
      ctaSecondary: '내 자산 평가받기',
    },
    about: {
      title: '전통의 신뢰 위에,',
      titleHighlight: '디지털의 혁신을 더하다.',
      description:
        '태범귀금속은 귀금속 시장의 투명한 거래 질서를 확립하고 고객 자산의 가치를 가장 합리적인 기준으로 평가하는 현물 자산 전문 기업입니다.',
      descriptionSub:
        '오랜 시간 축적된 감정 노하우와 시장 분석력을 기반으로 단순한 거래를 넘어, 정확한 기준과 신뢰를 제공하는 구조를 만들어갑니다.',
      points: {
        valuation: {
          title: '정직한 가치 산정',
          description:
            '엄격한 검인 체계를 통해 순도와 중량을 정확하게 평가합니다.',
        },
        realtime: {
          title: '실시간 시세 반영',
          description:
            '국내외 시세를 기반으로 시장가에 근접한 거래 기준을 제공합니다.',
        },
        customized: {
          title: '고객 맞춤 자산 관리',
          description: '개인과 기업 모두에게 최적화된 거래 환경을 제공합니다.',
        },
      },
      buyRequest: '매입 신청',
    },
    differentiators: {
      title: '유통을 줄이고,',
      titleHighlight: '기준을 높였습니다.',
      subtitle: '우리는 이렇게 다릅니다',
      items: {
        directPurchase: {
          title: '직접 매입 구조',
          description: '중간 유통 없이 더 높은 매입가를 제공합니다.',
        },
        refiningEvaluation: {
          title: '정련 기반 평가',
          description:
            '금, 은, 팔라듐, 구리 등 자산 가치를 더 정밀하게 판단합니다.',
        },
        directSupply: {
          title: '직접 공급 시스템',
          description: '기업 고객에게 안정적인 원자재 공급을 연결합니다.',
        },
      },
    },
    businessAreas: {
      title: '귀금속을 넘어,',
      titleHighlight: '산업 원자재까지.',
      description:
        '태범귀금속은 단순한 금 거래를 넘어 현물 자산 전반을 다루는 구조로 확장되고 있습니다.',
      items: {
        purchase: '순금 / 18K / 14K / 백금 / 은 / 구리 매입',
        supply: '골드바 / 실버바 공급',
        b2b: '기업 대상 원자재 B2B 공급',
        store: '직영점 운영',
        online: '플랫폼 온라인 사업 운영',
        production: '골드바 / 주얼제품 제작',
      },
    },
    platform: {
      subtitle: '가치를 더 투명하게, 거래를 더 견고하게',
      description:
        '폐쇄적이고 복잡했던 귀금속 거래 시장을 넘어, 누구나 더 명확한 정보와 더 신뢰할 수 있는 구조 안에서 거래할 수 있도록 태범이 새로운 디지털 플랫폼을 준비하고 있습니다.',
      bannerTitle: '기준을 위한 플랫폼, 곧 선보입니다',
      benefitsTitle: '플랫폼이 시장을 바꿉니다',
      benefits: {
        distribution: {
          title: '유통 구조 단축',
          description:
            '기존 다단계 유통을 제거하고 직접 거래 구조를 통해 판매자는 더 높은 가격, 구매자는 더 낮은 가격을 경험합니다.',
        },
        data: {
          title: '데이터 기반 시세',
          description:
            '실시간 시세와 거래 데이터를 공개하여 누구나 정확한 시장 기준으로 거래할 수 있습니다.',
        },
        trust: {
          title: '검증된 안전 거래',
          description:
            '태범귀금속의 감정 역량을 기반으로 모든 거래의 품질과 신뢰를 보증합니다.',
        },
      },
    },
    cta: {
      title: '지금, 당신의 자산 가치를 확인해보세요.',
      ctaPrimary: '실시간 시세 보기',
      ctaSecondary: '매입 상담 신청',
      step1: '온라인 매입 접수',
      step2: '매장 방문 & 정밀 감정',
      step3: '자산 확장',
    },
    goldPrice: {
      title: '실시간 금시세',
      prevDay: '전일 대비',
      changeRate: '변동률',
      international: '국제 시세',
      domestic: '국내 도매 시세',
      taebum: '태범 시세(살 때)',
      sell: '매입 시세(내가 팔때)',
    },
    report: {
      subtitle: '한눈에 보는 이슈',
      title: '태범리포트',
      viewAll: '전체 글 보기',
      readMore: '읽기',
      backToList: '목록으로',
      otherReports: '다른 리포트 보기',
      allCategory: '전체',
    },
    purchase: {
      title: '매입 상담 신청',
      description:
        '아래 정보를 입력해주시면, 담당자가 빠르게 연락드리겠습니다.',
      name: '이름',
      namePlaceholder: '홍길동',
      phone: '연락처',
      phonePlaceholder: '010-0000-0000',
      item: '품목',
      itemPlaceholder: '품목을 선택해주세요',
      items: {
        pureGold: '순금 (24K)',
        gold18k: '18K 금',
        gold14k: '14K 금',
        silver: '은',
        platinum: '백금',
        other: '기타',
      },
      weight: '중량 (g)',
      weightPlaceholder: '예: 37.5',
      memo: '메모',
      memoPlaceholder: '추가 요청 사항이 있으면 입력해주세요',
      submit: '신청하기',
      preparing:
        '현재 온라인 접수 기능을 준비 중입니다.\n매장으로 직접 연락주세요.',
      purchaseOnlyLabel: '매입',
    },
    footer: {
      companyName: '태범귀금속',
      copyright: 'All rights reserved.',
      privacy: '개인정보처리방침',
      terms: '이용약관',
    },
    voiceDiagnostic: {
      survey: {
        gender: {
          q: '당신의 보컬 베이스는 무엇인가요?',
          sub: '캐릭터의 기준 스탯이에요. 베이스에 따라 음역·공명 기준이 달라집니다.',
          opts: ['👩 여성 톤', '👨 남성 톤', '👻 신비주의 (비밀로 할래요)'],
        },
        birthYear: {
          q: '성대 나이 측정을 위해, 태어난 해를 알려주세요.',
          sub: '실제 나이와 ‘음성 나이’를 비교해 드릴게요.',
        },
        tier: {
          q: '당신의 현재 보컬 티어(Tier)는 어디쯤인가요?',
          sub: '결과를 당신 눈높이에 맞춰 설명해 드릴게요.',
          opts: [
            '⭐ Lv.1 · 샤워실의 케이팝스타',
            '⭐⭐ Lv.2 · 코인노래방 슈퍼스타',
            '⭐⭐⭐ Lv.3 · 동네 가요제 본선 진출',
            '⭐⭐⭐⭐ Lv.4 · 프로 지망생',
            '⭐⭐⭐⭐⭐ Lv.5 · 무대를 찢는 완성형',
          ],
        },
        wannabe: {
          q: '어떤 보컬 마스터로 전직하고 싶나요?',
          sub: '목표 보이스를 정하면, 그 기준으로 격차를 분석해 드려요.',
          opts: [
            '무대를 부수는 [파워풀 보이스]',
            '매력이 뚝뚝 [허스키 보이스]',
            '고막을 녹이는 [감성 꿀 보이스]',
            '사이다처럼 [맑고 청량한 보이스]',
            '압도적인 울림 [전문 성악가 보이스]',
            '아직 탐색 중! (잘 모르겠어요)',
          ],
        },
        purpose: {
          q: '이번 보컬 훈련의 메인 퀘스트(목표)는?',
          sub: '목적에 맞춰 결과에서 강조할 포인트를 골라드려요.',
          opts: [
            '음치·박치 탈출',
            '축가·장기자랑 박살 내기',
            '오디션·시험 합격',
            '취미로 즐겁게',
          ],
        },
        environment: {
          q: '쉿! 마이크 보정을 위해 조용한 곳인지 확인해 주세요.',
          sub: '정확한 분석을 위해 주변 소음이 없는 방 안이나 스튜디오를 권장해요.',
          opts: ['✅ 조용해요', '❌ 조금 시끄러워요'],
        },
        condition: {
          q: '오늘의 성대 컨디션(HP)은 어떠세요?',
          sub: '점수가 낮아도 컨디션 탓일 수 있어요. 결과에 참고할게요.',
          opts: [
            '🔋 Lv.1 완전 방전 (목이 아파요)',
            '😮‍💨 Lv.2 살짝 잠김',
            '🙂 Lv.3 보통',
            '💪 Lv.4 좋음',
            '🌟 Lv.5 풀 충전 (당장 녹음실로!)',
          ],
        },
      },
      stages: {
        low: {
          title: '퀘스트 1 · 땅굴 파기 ⬇️',
          cue: '거대한 소가 된 상상으로 “음~뭬에에” 성대를 편안하게 바닥 끝까지 내려가요',
          safety: '쥐어짜지 마세요 — 편하게 나오는 가장 낮은 음까지만',
        },
        high: {
          title: '퀘스트 2 · 로켓 발사 🚀',
          cue: '코에 진동을 팍! 사이렌처럼 “위이잉↗” 가장 높은 곳을 뚫어줘요',
          safety: '⚠️ 강제 고음은 성대 손상 위험! 절대 쥐어짜지 마세요',
        },
        sustain: {
          title: '퀘스트 3 · 호흡 방어전 🛡️',
          desc: '기준 음 ‘라(A)’를 잘 듣고, 흔들리지 않게 한 호흡으로 길게 “아—” 버텨주세요.',
          sub: '음정이 흔들리지 않을수록 방어 게이지가 끝까지 차올라요.',
          cue: '기준 음을 따라 “아~” 흔들림 없이 끝까지 유지',
        },
      },
      measure: {
        step: '측정 {{step}}',
        micLabel: '녹음 시작',
        micHint: '준비되면 마이크 버튼을 누르세요',
        secondsHeld: '초 유지',
        sustainCue: '최대한 길게 ‘아~’ 끌어보세요!',
        inputLevel: '입력 음량',
        refListen: '기준 음을 잘 들어보세요…',
        invalidVoice:
          '유효한 발성이 감지되지 않았어요. ‘아—’ 길게 끌기 단계에서 기준 음을 따라 한 음으로 안정적으로 길게 발성해 주세요.',
        micPermissionDenied:
          '마이크 권한이 거부되었습니다. 브라우저 주소창의 권한 설정을 허용으로 바꿔 주세요.',
        micUnsupported:
          '이 브라우저는 마이크 분석을 지원하지 않습니다. 최신 Chrome/Safari를 사용해 주세요.',
        coachingExcellent: '최고예요! 한계까지 더 버텨보세요',
        coachingGood: '좋아요, 그대로 끝까지 유지!',
        rangeMarkLow: '최저 ',
        rangeMarkHigh: '최고 ',
        loadingHeading: 'AI가 당신의 보컬 DNA를 정밀 분석하고 있습니다…',
        tipLabel: '팁',
        rangeNext: '다음 ▸',
      },
      nav: {
        prev: '이전',
        next: '다음',
        start: '측정 시작',
        yearSuffix: '{{year}}년',
      },
      save: {
        sending: '연구 데이터 전송 중…',
        stored: '✓ 연구용 데이터로 안전하게 보관되었습니다 (동의 기반)',
        demo: '✓ 분석 완료 · 저장 서버 연결 시 자동 전송됩니다 (데모)',
        offline: '✓ 분석 완료 · 백엔드 미연결 (서버 연결 후 자동 전송)',
      },
      toast: {
        consentRequired: '먼저 아래 [필수] 항목에 동의해 주세요!',
        selectOption: '이 항목을 선택해 주세요!',
        linkCopied: '결과 링크를 복사했어요!',
        linkCopyUnsupported: '링크 복사를 지원하지 않는 브라우저예요.',
      },
      tips: [
        {
          label: '싱어즈 포먼트',
          body: '‘싱어즈 포먼트’는 밴드의 거친 반주를 뚫고 내 목소리만 관객에게 또렷하게 전달되게 만드는 마법의 주파수(약 3kHz)랍니다!',
        },
        {
          label: '믹스 보이스',
          body: '‘믹스 보이스’는 흉성(가슴 울림)과 두성(머리 울림)을 섞어, 고음에서도 목이 조이지 않게 내는 궁극의 스킬이에요.',
        },
        {
          label: '바이브레이션',
          body: '비브라토의 황금 비율은 1초에 약 5~7번 음정이 부드럽게 떨리는 것을 말해요.',
        },
        {
          label: '고음 발성법',
          body: '고음의 핵심은 목에 힘을 꽉 주는 게 아니라, 안정적인 호흡 압력과 얇고 섬세한 성대 접촉에 있어요.',
        },
      ],
      intro: {
        titleLead: '뮤즐리 AI가 당신의 ',
        titleHighlight: '보컬을 진단',
        titleTail: '해 드릴게요.',
        subLine1: '간단한 설문과 3단계 음성 측정으로',
        subLine2: '음역·음색·발성을 데이터로 분석합니다.',
        consentRequired: '[필수]',
        consentBody:
          ' 진단을 위해 마이크 녹음이 진행되며, MUZLY가 이 녹음과 분석 지표를 음성 AI 연구·모델 고도화 목적으로 안전하게 보관·활용하는 데 동의합니다. ',
        consentLink: '연구 데이터 활용 안내 보기',
        start: '보컬 진단 시작 →',
      },
      voiceTest: {
        eyebrow: 'Live Demo · AI 보컬 인바디',
        titleLead: '내 목소리, ',
        titleHighlight: '데이터로',
        titleTail: ' 읽다',
        titleLine2: '음역부터 음색까지 한 번에',
        body: '간단한 설문 후 최저음·최고음·지속 발성 3단계를 측정해요. AI가 음역·성부·음정·음색·발성·싱어즈 포먼트까지 분석해 나만의 보컬 인바디 리포트를 만들어 드립니다.',
        cardTitle: 'AI 음성 진단',
      },
      result: {
        rankTop: '예상 상위',
        rankSub: 'AI가 추정한 예상 백분위 (베타)',
        replay: '내 녹음 다시 듣기',
        betaLabel: '베타 안내 ·',
        betaBody:
          '현재 진단 지표는 개발 중인 단계로, 결과가 정확하지 않을 수 있습니다. MUZLY는 동의 기반으로 수집된 음성 데이터를 바탕으로 분석 엔진을 지속적으로 학습·고도화하여, 점점 더 정교한 진단으로 발전시켜 나가겠습니다.',
        share: '친구에게 결과 공유',
        retry: '다시 측정하기',
      },
      grade: {
        s: 'S · 프로페셔널',
        a: 'A · 탁월',
        b: 'B · 우수',
        c: 'C · 발전 중',
        d: 'D · 입문',
        desc: '{{voice}} 목소리 · {{character}} 음색. 6개 지표를 종합한 보컬 인덱스예요.',
      },
      metrics: {
        pitchAccuracy: {
          label: '음정 정확도',
          desc: '기준 A음과의 평균 오차 {{cents}} cents',
        },
        pitchStability: {
          label: '음정 안정성',
          desc: '피치 흔들림(표준편차) {{cents}} cents',
        },
        sustain: {
          label: '호흡 지속력',
          desc: '안정 발성 약 {{sec}}초 지속',
        },
        vibrato: {
          label: '비브라토',
          desc: '음정의 규칙적 떨림 정도',
        },
        resonance: {
          label: '공명',
          desc: '배음 대비 잡음비(HNR) 기반 공명',
        },
        singersFormant: {
          label: '싱어즈 포먼트',
          desc: '2.8~3.4kHz 고배음 에너지(성악적 울림)',
        },
      },
      voiceType: {
        label: '{{tone}} {{range}}',
        tone: {
          warm: '따뜻한',
          balanced: '균형 잡힌',
          bright: '밝은',
        },
        range: {
          low: '저음형',
          midLow: '중저음형',
          midHigh: '중고음형',
          high: '고음형',
        },
      },
      detail: {
        head: '상세 보컬 리포트',
        preciseBadge: '정밀분석 반영',
        rangeLabel: '당신의 음역대',
        rangeSub: '약 {{semitones}} 반음 ({{low}}–{{high}} Hz)',
        fach: '성부',
        fachValues: {
          soprano: '소프라노',
          alto: '알토',
          tenor: '테너',
          bass: '베이스',
          soprano_tenor: '소프라노·테너 권',
          alto_bass: '알토·베이스 권',
        },
        voiceAge: '음성 나이',
        ageUnit: '세',
        actualAge: '실제 {{age}}세',
        character: '음색',
        characterValues: {
          breathy: '허스키한',
          pressed: '압착·파워풀한',
          clear: '청초하고 맑은',
          bright: '맑고 시원한',
          balanced: '균형 잡힌',
          warm: '따뜻하고 부드러운',
        },
        similarArtists: '비슷한 음역의 아티스트',
      },
      resonance: {
        title: '공명·발성 위치 진단',
        aria: '보컬 트랙(성도) 공명 진단',
        points: {
          hardPalate: '경구개',
          lips: '입술',
          tongue: '혀',
          softPalate: '연구개',
          vocalFolds: '성대',
        },
        notes: {
          velum: {
            title: '연구개',
            desc: '연구개가 충분히 열리지 않아 공명이 위로 전달되지 않고 있어요.',
          },
          fold: {
            title: '성대',
            desc: '성대에 긴장이 집중되고 있어요.',
          },
          tongue: {
            title: '혀',
            desc: '혀 뒤가 눌려 소리가 다소 먹먹하게 들릴 수 있어요.',
          },
          balanced: {
            title: '균형 잡힌 공명',
            desc: '공명 위치가 비교적 안정적으로 분포해 있어요. 지금 밸런스를 유지해 보세요.',
          },
        },
      },
      register: {
        title: '두성·믹스·흉성 공명 비율',
        head: '두성',
        mix: '믹스',
        chest: '흉성',
        headResonanceLabel: '두성공명',
        chestResonanceLabel: '흉성공명',
      },
      singersFormant: {
        title: '싱어즈 포먼트 맵',
        aria: '배음 스펙트럼과 싱어즈 포먼트',
        bandLabel: '싱어즈 포먼트 ≈3kHz',
        cap: '기본음 F0 {{f0}}Hz의 배음(harmonics)이 ≈3kHz 대역에 모일수록 ‘싱어즈 포먼트’가 강해요. 형성도 {{score}}/100',
        capSpr: ' · SPR {{spr}}dB(낮을수록 강함)',
        capFormants: ' · F3 {{f3}}Hz · F4 {{f4}}Hz',
        capFormantsPending: ' · F3·F4 정밀값 분석 중…',
      },
      engineMap: {
        title: '분석 엔진 매핑',
        openSource: '오픈소스',
        desc: '각 지표가 실제로 어떤 음성 분석 도구로 측정되는지 투명하게 공개해요.',
        rows: [
          {
            metric: '발성 구간 검출',
            desc: '무음·잡음을 제거하고 유효 발성만 추출',
          },
          { metric: '음역·음정 (F0)', desc: '최저·최고음, 음정 정확도·안정성' },
          {
            metric: '공명·음색·음질·포먼트',
            desc: '포먼트 F1~F4 · HNR · jitter/shimmer · CPPS',
          },
          {
            metric: '두성·믹스·흉성 (발성 방식)',
            desc: '스펙트럴 틸트 · H1−H2 (성문 개방비)',
          },
          {
            metric: '싱어즈 포먼트 (≈3kHz)',
            desc: 'LTAS 장기평균스펙트럼 · SPR(Singing Power Ratio)',
          },
          {
            metric: '비브라토·스펙트럼',
            desc: '음정 떨림(4~9Hz) · 스펙트럴 중심',
          },
          {
            metric: '실시간 라이브 피치',
            desc: '측정 중 브라우저 자기상관(ACF) 분석',
          },
        ],
      },
      badge: {
        estimated: '추정',
      },
    },
  },
  web: {
    common: {
      // 설문 단계의 CTA. 안내 화면의 `다음`과 갈라 둔다 — 답하는 화면과
      // 읽고 넘어가는 화면은 같은 문구를 쓰면 안 된다(시안).
      continue_: '계속',
      appName: 'MUZLY',
      // 설문 셸·이력 헤더가 같이 쓰는 내비 문구 — 화면마다 다른 말이 되면 안 된다.
      back: '이전',
      next: '다음',
      // 설문 셸 진행 바의 접근 가능한 이름(WCAG 4.1.2) — 시각적으로만 보이는 채움
      // 막대에 스크린리더가 읽을 텍스트를 준다.
      progress: '{{total}}단계 중 {{current}}번째',
    },
    offline: {
      offline: '오프라인 상태입니다',
      recovered: '연결이 복구되었습니다',
    },
    // 공유 링크 게이트웨이(`/link?to=`) — 모바일 브라우저에서 앱 열기를 시도한 뒤 보이는 화면.
    link: {
      opening: '뮤즐리 앱으로 여는 중이에요',
      hint: '앱이 열리지 않으면 웹에서 이어서 볼 수 있어요.',
      continueWeb: '웹에서 계속하기',
    },
    // 점수 축의 **이름·근거 정본**(metricGrades). 홈 요약·추세 토글·결과 카드·이력이
    // 전부 여기를 읽는다 — 한 숫자가 화면마다 다른 이름으로 보이면 두 지표로 읽힌다.
    metrics: {
      grade: {
        solid: '견고',
        proxy: '간접 지표',
        weak: '근거 약함',
      },
      sustain: {
        label: '호흡 지속',
        note: '한 호흡으로 낸 소리의 길이를 그대로 잽니다. 점수는 12초를 만점으로 둔 자체 눈금이라, 참고 구간과는 자가 달라요.',
      },
      pitchAccuracy: {
        label: '음정 정확도',
        note: '부른 음이 가장 가까운 반음에서 얼마나 벗어났는지 봅니다. 정해진 멜로디와 맞춰본 게 아니라, 어떤 음이든 고르게 내면 높게 나와요.',
      },
      pitchStability: {
        label: '음정 안정성',
        note: '음높이가 얼마나 흔들렸는지로 봅니다. 임상에서 말하는 성대 안정성(jitter·shimmer)과는 다른 지표예요.',
      },
      vibrato: {
        label: '비브라토',
        note: '음높이의 규칙적인 흔들림을 세는 자체 방식이에요. 검증된 기준이 아직 없어 참고로만 봐 주세요.',
      },
    },
    language: {
      label: '언어',
      // 언어 표시명은 두 로케일 모두 자국어 표기를 쓴다
      ko: '한국어',
      en: 'English',
    },
    tabs: {
      home: '홈',
      more: '더보기',
    },
    // 마이페이지(더보기 탭) — 시안 없음. 프로필 카드 · 요약 · 설정 목록. 문서 본문은 자리표시자다.
    more: {
      title: '마이페이지',
      profile: '프로필 수정',
      history: '진단 결과',
      privacy: '개인정보처리방침',
      version: '앱 버전',
      versionWeb: 'v{{web}}',
      // 네이티브 셸 안에서는 앱 버전이 따로 있다 — 웹 번들 버전과 같이 적는다.
      versionNative: 'v{{app}} ({{build}}) · 웹 v{{web}}',
      guest: '게스트',
      stats: {
        runs: '진단 횟수',
        runsValue: '{{count}}회',
        latest: '최근 점수',
        range: '내 음역',
        none: '—',
      },
      groups: {
        activity: '내 활동',
        settings: '설정',
        support: '고객 지원',
        legal: '약관 및 정책',
        app: '앱 정보',
      },
      items: {
        diagnose: '새 진단 시작',
        language: '언어',
        notifications: '알림 받기',
        notice: '공지사항',
        faq: '자주 묻는 질문',
        contact: '문의하기',
        terms: '서비스 이용약관',
        licenses: '오픈소스 라이선스',
      },
      contactCta: '이메일로 문의하기',
      // 문서 본문 — **자리표시자 문구**다. 실제 약관·방침은 법무 검토본으로 갈아 끼운다.
      docs: {
        terms: {
          title: '서비스 이용약관',
          body: '제1조 (목적)\n본 약관은 뮤즐리(이하 "회사")가 제공하는 보컬 진단 서비스의 이용 조건과 절차, 회사와 이용자의 권리·의무를 정합니다.\n\n제2조 (정의)\n"서비스"란 이용자의 음성을 분석해 음역·음정·호흡 등의 지표를 제공하는 기능 일체를 말합니다.\n\n제3조 (약관의 효력)\n본 약관은 앱 화면에 게시함으로써 효력이 발생하며, 회사는 관련 법령을 위반하지 않는 범위에서 약관을 개정할 수 있습니다.\n\n제4조 (서비스의 제공)\n회사는 연중무휴 서비스를 제공하는 것을 원칙으로 하되, 점검·장애 등 부득이한 사유가 있으면 일시 중단할 수 있습니다.\n\n(이 문서는 자리표시자입니다. 정식 약관으로 교체해 주세요.)',
        },
        privacy: {
          title: '개인정보처리방침',
          body: '뮤즐리는 이용자의 개인정보를 소중히 다루며, 개인정보 보호법 등 관련 법령을 준수합니다.\n\n1. 수집하는 항목\n닉네임, 성별, 출생연도, 설문 응답, 진단을 위해 녹음한 음성 데이터와 그 분석 결과.\n\n2. 이용 목적\n보컬 진단 결과 제공, 회차별 변화 추적, 분석 엔진 개선.\n\n3. 보관 및 파기\n진단 기록은 이용자의 기기에 저장되고, 분석 결과와 진단에 사용한 녹음은 결과 재생을 위해 서버에도 보관됩니다. 기기의 기록은 이용자가 삭제하거나 앱을 삭제하면 함께 사라집니다.\n\n4. 문의\n개인정보 관련 문의는 support@muzly.io 로 보내 주세요.\n\n(이 문서는 자리표시자입니다. 정식 방침으로 교체해 주세요.)',
        },
        notice: {
          title: '공지사항',
          body: '[안내] 뮤즐리 베타 서비스 시작\n4단계 보컬 진단을 베타로 열었어요. 진단 결과는 측정 환경과 컨디션에 따라 달라질 수 있어요.\n\n[업데이트] 결과 상세 화면 개편\n지표 7종의 상세 차트를 새로 그렸어요. 홈 타일을 누르면 바로 그 지표로 이동해요.\n\n(이 문서는 자리표시자입니다.)',
        },
        faq: {
          title: '자주 묻는 질문',
          body: 'Q. 진단은 얼마나 자주 하면 좋나요?\n일주일에 1~2회, 비슷한 시간대와 환경에서 재면 변화가 잘 보여요.\n\nQ. 결과가 매번 다르게 나와요.\n목 상태·주변 소음·마이크 거리에 따라 값이 흔들릴 수 있어요. 조용한 실내에서 재 보세요.\n\nQ. 녹음한 음성은 어디에 저장되나요?\n분석 결과는 기기에 저장되고, 진단에 사용한 녹음은 결과를 다시 들을 수 있도록 서버에 보관돼요.\n\n(이 문서는 자리표시자입니다.)',
        },
        contact: {
          title: '문의하기',
          body: '이용 중 불편한 점이나 궁금한 점이 있으면 알려 주세요. 영업일 기준 2일 안에 답변드려요.\n\n이메일: support@muzly.io',
        },
        licenses: {
          title: '오픈소스 라이선스',
          body: '이 앱은 아래 오픈소스 소프트웨어를 사용합니다.\n\nReact — MIT License\nReact Native — MIT License\nReact Router — MIT License\ni18next — MIT License\nlucide — ISC License\nPretendard — SIL Open Font License 1.1\n\n(이 문서는 자리표시자입니다.)',
        },
      },
    },
    home: {
      diagnosis: {
        section: '보컬 진단',
        // 단계 수는 화면이 RECORD_TESTS에서 센다 — 문구에 숫자를 굳히면 진단이 늘 때 어긋난다.
        subtitle: '{{count}}단계 진단으로\n내 목소리를 확인해 보세요',
        start: '진단하기',
        resume: '이어서 진단하기',
        duration: '약 {{value}}분 소요',
      },
      // 진단 이어하기 팝업(시안 `1048:48431`) — 진행 중인 회차가 있을 때 홈 진입 시.
      resume: {
        title: '이전 진단이 저장되어 있어요',
        // "진행 중"인 단계 = 마친 수 + 1. 분모는 RECORD_TESTS.
        status: '{{current}}/{{total}} 단계 진행 중',
        body: '마지막으로 진행한 단계부터\n이어서 진행하거나\n처음부터 다시 시작할 수 있어요',
        restart: '새로 시작',
        continue_: '이어서 진단',
        dismiss: '닫기',
      },
      recent: {
        section: '최근 진단 결과',
        overall: '종합 점수',
        score: '{{value}} / 100',
        pending: '측정 준비 중',
        uncalibrated: '종합 점수는 측정된 축의 균등 평균이에요 (가중치 미보정)',
        all: '결과 전체 보기',
      },
      // 지표 타일 일곱(시안 §7.1) — 이름은 상세 탭과 같은 키를 쓴다.
      tiles: {
        section: '최근 진단 결과',
        // 타일은 좁다 — 상세(`web.result.range.notes`)의 `E2 ~ C5`보다 붙여 쓴다(시안 §7.1).
        range: '{{low}}-{{high}}',
        hz: '{{value}}Hz',
        // 헤더 오른쪽의 회차 날짜(시안 `2026. 00. 00 >`) — 이력으로 가는 링크.
        date: '{{year}}. {{month}}. {{day}}',
      },
      trend: {
        section: '최근 보컬 추세',
        // 시안 §7.1의 기간 셀렉트. 값이 들어가는 문장이라 하드코딩하지 않는다.
        period: '최근 {{value}}일',
        periodLabel: '추세 기간',
        outOf: '/ 100',
        // 창의 첫 값 대비다. 직전 회차 대비가 아니다 — 카드가 말하는 건 "요즘 어떤가"다.
        deltaUp: '{{value}}점 향상',
        deltaDown: '{{value}}점 하락',
        // "2회"가 아니라 "이틀"이다 — 하루 집계라 같은 날 두 번 재면 점이 하나다.
        empty: '이틀 이상 진단해야 추세가 보여요',
        // 차트의 텍스트 대안. 축 이름은 축 정본(scoredMetrics)에서 온다.
        alt: '{{axis}} 최근 7일 추세 — 마지막 측정 {{date}} {{value}}',
        altEmpty: '{{axis}} 최근 7일 추세 — 측정값 없음',
      },
    },
    profile: {
      title: '프로필',
      identity: '내 정보',
      answers: '내 답변',
      hint: '여기서 고친 답은 다음 진단에 그대로 쓰여요.',
      unanswered: '아직 답하지 않았어요',
      save: '저장',
      saved: '저장했어요',
      // 설문 화면의 질문("{{nick}}님 노래를\n얼마나 파보셨어요?")을 그대로 라벨로 쓰면
      // 줄바꿈이 섞인 문장이 목록에 눕는다. 목록에서는 무엇을 고르는 자리인지만 부른다.
      fields: {
        gender: '목소리 기준점',
        birthYear: '나이',
        experience: '노래 경험',
        style: '워너비 목소리',
        purpose: '이용 목적',
      },
      // 프로필 사진. 사진은 이 기기에만 저장되고 서버로 가지 않는다 — 그 사실을
      // 사용자가 알아야 기기를 바꿀 때 사라지는 걸 이해한다.
      photo: {
        label: '프로필 사진',
        alt: '내 프로필 사진',
        empty: '사진 없음',
        change: '사진 바꾸기',
        add: '사진 추가',
        camera: '카메라로 촬영',
        library: '앨범에서 고르기',
        remove: '사진 삭제',
        cancel: '취소',
        localOnly: '사진은 이 기기에만 저장돼요.',
        denied: '사진을 쓰려면 설정에서 권한을 켜 주세요.',
        failed: '사진을 불러오지 못했어요. 다시 시도해 주세요.',
      },
    },
    // 시안의 분홍 캐릭터. 여러 화면이 같은 그림을 쓴다.
    brand: {
      mascotAlt: '뮤즐리 마스코트',
    },
    onboarding: {
      // 줄바꿈은 문구가 소유한다 — 화면은 whitespace-pre-line으로 받는다.
      // '기타'를 고른 뒤 뜨는 자유 입력 — 어느 설문 단계에서든 같은 문구다.
      other: {
        placeholder: '직접 입력해 주세요',
        label: '기타 직접 입력',
      },
      nick: {
        title: '뮤즐리에서 사용할 닉네임과\n언어를 선택해 주세요',
        subtitle: '닉네임은 설정에서 언제든 변경 가능해요',
        label: '닉네임',
        placeholder: '이름 입력',
        // 시안의 `Description` 자리. 왜 잘리는지 말하지 않으면 상한이 고장으로 읽힌다.
        hint: '최대 {{max}}자까지 쓸 수 있어요',
        // 이후 스텝 제목이 닉네임을 부른다 — 값이 비어 있는 드래프트를 위한 대체 호칭
        fallback: '회원',
      },
      gender: {
        title: '먼저, 당신의 목소리\n기준점을 잡을게요',
        subtitle: '성별에 따라 음역·공명 기준이 달라서 필요해요.',
        options: {
          female: '여성',
          male: '남성',
          none: '밝히지 않을래요',
        },
      },
      birthYear: {
        title: '{{nick}}님의\n나이를 알려주세요.',
        subtitle: '정확한 분석을 위해서 필요해요.',
        placeholder: '나이 선택',
        // 나이 + 출생연도(TestFlight #55). 저장 값은 출생연도다.
        option: '{{age}}세 ({{value}}년생)',
      },
      experience: {
        title: '{{nick}}님 노래를\n얼마나 파보셨어요?',
        options: {
          first: '이번에 처음 배워요',
          hobby: '취미로만 해봤어요',
          lesson: '레슨 받아본 적 있어요',
          pro: '수준급 프로랍니다',
        },
      },
      style: {
        title: '어떤 목소리를 갖고 싶으세요?',
        subtitle: '닮고 싶은 스타일을 고르면, 그 기준으로 비교해드려요.',
        options: {
          powerful: '파워풀 가창',
          ballad: '감성 발라드',
          pop: '청량 팝',
          classic: '성악·뮤지컬',
          jazz: '재즈·소울',
        },
      },
      purpose: {
        title: '{{nick}}님 오늘은\n어떤 마음으로 오셨나요?',
        options: {
          curious: '그냥 궁금해서',
          check: '실력 점검을 위해서',
          track: '꾸준한 성장 트래킹',
          audition: '오디션, 시험 준비',
        },
      },
      environment: {
        title: '지금 계신 곳은 조용한가요?',
        subtitle: '주변이 시끄러우면 분석이 흔들릴 수 있어요!',
        options: {
          quiet: '조용한 실내',
          noisy: '시끄러운 실내',
          outdoor: '야외',
        },
      },
      condition: {
        title: '오늘 목 상태는 어떤가요?',
        options: {
          best: '최상',
          normal: '보통',
          husky: '살짝 잠김',
          // 옛 워딩이 직관적이지 않다는 리뷰(TestFlight #60) — 보통·살짝 잠김과 같은 축으로.
          bad: '많이 잠김',
        },
      },
      // 설문이 끝났다는 쉼표(시안 `758:20959`).
      surveyDone: {
        title: '나를 위한 보컬 설정이\n완료됐어요!',
        banner: '내 목소리를 직접 확인해 볼까요?',
      },
    },
    diagnosis: {
      // 나가도 진행은 남는다 — 홈 카드가 "이어서 진단하기"로 받는다.
      close: '진단 나가기',
      // 진단 개수·이름은 화면이 RECORD_TESTS에서 센다 — 문구에 숫자를 굳히면
      // 테스트가 늘 때 화면과 문장이 어긋난다.
      intro: {
        testsTitle: '보컬 진단은 {{value}}가지 목소리 테스트를 진행해요',
        durationTitle: '보컬 진단은 약 {{value}}분 정도 소요돼요',
        durationSubtitle: '잘 부르지 않아도 괜찮아요\n편안하게 소리내 주세요',
        slides: '안내 {{current}} / {{total}}',
        prev: '이전 안내',
        next: '다음 안내',
        cta: '진단하기',
      },
      guide: {
        preview: '멜로디 미리듣기',
        previewStop: '미리듣기 정지',
        // 지속음 진단의 기준음 미리듣기 — 멜로디가 아니라 음 하나라 문구가 따로다.
        previewTone: '기준 음 들어보기',
        previewToneStop: '기준 음 정지',
        step: '{{current}} / {{total}}',
        duration: '소요시간 {{value}}',
        unlimited: '제한 없음',
        seconds: '{{value}}초',
        start: '진단 시작하기',
      },
      tests: {
        sustain: {
          title: '기본 발성 측정',
          summary: '기준 음 라(A)를 따라 아~ 소리를 유지해요',
          // 기준 음을 문구로도 부른다 — 소리만 들려주면 놓친 사람이 아무 음이나 낸다.
          // 옥타브는 말하지 않는다: 편한 옥타브의 라면 되고, 판정도 그렇게 돈다
          // (`sustainGuide.latchedTarget`이 첫 발성의 옥타브로 축을 내려 잡는다).
          desc: '기준 음 라(A)를 들어보고, 편한 옥타브의 같은 음으로 숨이 닿는 만큼 길게 소리 내주세요.',
        },
        low: {
          title: '저음역대 측정',
          summary: '가능한 범위 안에서 가장 낮은 소리를 내요',
          desc: '본인이 낼 수 있는 가장 깊은 저음까지 천천히 미끄러지듯 내려가 보세요.',
        },
        high: {
          title: '고음역대 측정',
          summary: '무리하지 않는 선에서 가장 높은 소리를 내요',
          desc: '무리하지 않는 선에서 가장 높은 음까지 서서히 끌어올려 보세요.',
        },
        song: {
          title: '실전 가창 측정',
          summary: '들려주는 멜로디를 그대로 따라 불러요',
          desc: '짧은 멜로디가 재생돼요. 같은 음을 같은 박자로 따라 불러 주세요. 가사 없이 "아—"로 불러도 괜찮아요.',
        },
      },
      segments: {
        sustain: {
          title: '기준 음 라(A)에 맞춰 “아—” 소리를 길게 내주세요.',
          subtitle:
            '소리가 끊길 때까지 편하게 뻗고, 끊기면 완료를 눌러 주세요.',
          upNext: '이제 기준 음 라(A)로 “아—” 소리를 길게 내볼게요',
        },
        low: {
          title: '“아—” 소리로 낼 수 있는 가장 낮은 음까지 내려가 보세요.',
          subtitle: '한 음씩 천천히. 더 내려가지 않으면 완료를 눌러 주세요.',
          upNext: '이제 가장 낮은 음을 내볼게요',
        },
        high: {
          title: '이번엔 편하게 낼 수 있는 가장 높은 음까지 올라가 보세요.',
          subtitle: '목이 아프면 바로 멈추세요. 무리해서 올릴 필요 없어요.',
          upNext: '이제 가장 높은 음을 내볼게요',
        },
        song: {
          title: '들리는 멜로디를 그대로 따라 불러 주세요.',
          subtitle:
            '음과 박자를 같이 맞춰 보세요. 놓친 부분은 그냥 넘어가도 괜찮아요.',
          upNext: '이제 멜로디를 따라 불러볼게요',
        },
      },
      track: {
        // 지속음 타임라인 — 기준음을 유지한 구간이 채워지고, 표식은 기준음 대비 위아래로 움직인다.
        label: '기준음을 유지한 구간이 채워지는 타임라인',
        traceLabel: '시간에 따른 소리의 높낮이',
        gaugeLabel: '지금 내고 있는 음의 높이',
        vowel: 'Ah',
        sharpBy: '+{{value}} cents',
        flatBy: '−{{value}} cents',
        // 트랙 위 현재 음 표기 — 시안이 영문 음이름과 계이름을 함께 쓴다(`A3(라)`).
        noteWithSolfege: '{{note}}({{solfege}})',
        currentNote: '현재 음정',
        tick: {
          high: '고음',
          mid: '중간',
          low: '저음',
        },
      },
      countdown: {
        announce: '{{value}}초 후 시작해요',
      },
      // 주변 소음으로 측정이 성립하지 않을 때의 전체화면(시안 `884:9858`).
      noisyRoom: {
        title: '주변 소음으로 측정이\n정확하지 않아요.',
        banner: '조용한 환경에서 다시 측정하면 더 정확해요!',
        retry: '다시 측정하기',
      },
      record: {
        start: '녹음 시작',
        finish: '녹음 완료',
        finishLabel: '완료',
        noVoiceYet: '소리가 아직 안 잡혀요',
        replayDisabled: '녹음 중에는 멜로디를 다시 들을 수 없어요',
        recording: '녹음 중',
        elapsed: '{{value}}초',
        // 제한시간은 눈금이 아니라 마감이다 — 남은 시간을 말한다.
        remaining: '남은 시간 {{value}}초',
        // 큰 타이머 위 라벨. 예전엔 키만 있고 번역이 없어 화면에 키가 그대로 찍혔다.
        elapsedLabel: '경과 시간',
        // 지금 마이크가 무엇을 듣고 있는지 한 줄. 진행 상태와 달리 **소리** 이야기다.
        listening: {
          idle: '가능한 만큼 편안하게 유지해 보세요',
          hearing: '목소리를 잘 듣고 있어요',
          // 소리는 나는데 이 방 기준으로 작다 — 처방이 "더 크게"다(시안 `884:8299`).
          faint: '목소리가 작아요! 조금만 더 크게 소리를 내주세요.',
          silent: '목소리가 감지 되지 않았어요! 편안하게 소리를 내주세요.',
        },
        // 노래 진단은 멜로디가 끝나면 기계가 끊는다 — 그 동안 완료 버튼 자리는
        // 누를 것이 아니라 상태다(시안 `1017:17872`).
        measuring: '측정 중',
        waveformLabel: '목소리를 듣는 중',
        // 일시 중단 — 멈춘 동안에는 소리가 어디에도 안 남는다(useVoiceCapture.pause).
        pause: '일시 중단',
        resume: '이어서 측정',
      },
      // 음역의 양끝. 완료 요약(describeAttempt: "최저 A2")과 그래프의 도달점 배지
      // ("최저 도3")가 **같은 문장**이라 키도 하나다 — 음이름 표기만 서로 다르다.
      bound: {
        low: '최저 {{note}}',
        high: '최고 {{note}}',
      },
      // 방금 시도가 뭘 남겼는지 한 줄. 순수 함수(describeAttempt/attemptWarning)가
      // 키를 돌려주고 화면이 번역한다.
      attempt: {
        noSound: '소리가 잡히지 않았어요',
        sustain: '{{value}}초 발성',
        unstable:
          '음이 흔들려서 분석이 어려울 수 있어요. 한 음을 고르게 뻗어 주세요.',
      },
      pitchGraph: {
        label: '실시간 음정',
      },
      song: {
        loading: '따라 부를 멜로디를 준비하고 있어요',
        // 음원을 못 받으면 이 진단만 못 한다 — 앞의 두 진단은 이미 쟀다.
        loadFailed:
          '멜로디를 불러오지 못했어요. 다시 시도하거나, 이 테스트만 건너뛰어도 결과는 나와요.',
        retry: '다시 시도',
        skip: '이 테스트 건너뛰기',
        // 채점 결과 — 정확도와 함께 **몇 음을 불렀는지**를 같이 낸다. 반만 부르고 100%가
        // 뜨면 사용자는 그걸 완창으로 읽는다.
        result: '음정 정확도 {{accuracy}}% · {{total}}음 중 {{sung}}음',
        // 소리를 안 냈거나 멜로디에 맞댈 게 없을 때 — 0%가 아니다.
        unmeasured: '맞춰볼 소리가 잡히지 않았어요',
        tendency: {
          low: {
            flat: '낮은 음 구간이 대체로 음보다 낮았어요',
            sharp: '낮은 음 구간이 대체로 음보다 높았어요',
          },
          high: {
            flat: '높은 음 구간이 대체로 음보다 낮았어요',
            sharp: '높은 음 구간이 대체로 음보다 높았어요',
          },
        },
      },
      review: {
        heading: '이번 측정 결과',
        testDone: '<{{test}}> 진단이 완료되었어요',
        nextTestHint: '다음 진단을 시작할게요!',
        lastTestHint: '이제 결과를 분석할게요!',
        attempts: '{{value}}번 시도 — 가장 좋은 기록이 남아요',
        retry: '재진단',
        confirm: '확인',
      },
      // 한 진단을 마친 전체화면(시안 `884:9451`). 세그먼트 사이의 작은 다이얼로그와 다르다.
      stepDone: {
        title: '{{step}}단계 {{test}}\n측정을 완료했어요',
        retry: '재 측정',
        next: '다음',
      },
      // 전부 마친 전체화면(시안 `893:13968`).
      allDone: {
        title: '모든 진단이 끝났어요!',
        body: '정말 고생하셨어요.\n입력된 데이터를 바탕으로 정밀한\n나만의 결과를 만들었어요!',
        result: '결과 확인',
      },
      done: {
        title: '테스트 {{value}}개 완료',
        result: '결과 보기',
        retry: '다시 녹음',
      },
      error: {
        denied: '마이크 사용 권한이 필요해요. 설정에서 허용해 주세요.',
        unsupported: '이 기기에서는 음성 녹음을 지원하지 않아요.',
        invalid: '음성이 충분히 안정적이지 않았어요. 다시 녹음해 주세요.',
        mockInvalid:
          '브라우저에서는 마이크 대신 합성 음성을 분석해요 — 실측이 아니라 분석이 끝까지 가지 않아요. 실제 진단은 앱에서 해주세요.',
        retry: '다시 녹음',
      },
    },
    history: {
      title: '진단 결과',
      intro: '회차별로 직전 진단과 비교해서 보여드려요.',
      emptyTitle: '아직 저장된 회차가 없어요',
      // 기간 필터로 비었을 때 — 저장된 회차는 있다.
      emptyPeriod: '이 기간에는 진단한 회차가 없어요',
      // 회차 카드의 종합 점수(시안 `78점`).
      score: '{{value}}점',
      emptyBody:
        '진단을 마치면 회차가 쌓여요. 브라우저에서 한 진단은 합성 음성이라 저장하지 않아요 — 실제 회차는 앱에서 쌓입니다.',
      restart: '새로 진단하기',
      // 회차 구분용 날짜. Intl 대신 Date 필드를 로케일 서식에 끼운다 — 타임존에 안 흔들린다.
      date: '{{month}}월 {{day}}일',
      // 호흡 지속 시간은 결과 화면과 **같은 값**이라 키도 같다(`web.result.sustain.seconds`).
      // 여기에 따로 두면 같은 숫자가 화면마다 다른 단위 표기를 갖게 된다.
      // 직전 대비 변화. 부호는 값에 이미 붙어 있다(`+2.1`).
      delta: {
        sec: '{{value}}초',
        point: '{{value}}점',
      },
    },
    // 결과 화면(덱 p10) — 진단 1·2·3 + 종합. 안 잰 값은 전부 `pending`이다(0 금지).
    result: {
      title: '보컬 진단 결과',
      // 회차 하나를 다시 여는 상세 화면(시안 §8.2)의 헤더.
      detail: {
        title: '진단 결과',
      },
      subtitle: '녹음에서 실제로 잰 값만 보여드려요.',
      pending: '측정 준비 중',
      // 임계값이 아직 보정 전이라는 걸 값 옆에서 밝힌다(metricGrades 등급과 같은 취지).
      uncalibrated: '미보정 기준',
      score: '{{value}} / 100',
      mock: '브라우저에서는 마이크 대신 합성 음성을 분석해요. 이 결과는 저장되지 않아요.',
      failed: {
        title: '분석에 실패했어요',
        body: '음성이 충분하지 않았어요. 다시 녹음해 주세요.',
        retry: '다시 녹음',
      },
      env: {
        noisy:
          '측정할 때 주변이 시끄러웠어요 — 이번 결과는 참고용으로만 봐 주세요',
      },
      condition: {
        best: '오늘 목 상태가 최상이라고 하셨어요 — 요즘 낼 수 있는 최고치에 가까운 값이에요.',
        normal: '오늘 목 상태는 보통이라고 하셨어요.',
        husky:
          '오늘 목이 살짝 잠겼다고 하셨어요 — 맑기와 고음이 평소보다 낮게 나올 수 있어요.',
        bad: '오늘 목이 많이 잠겼다고 하셨어요 — 컨디션이 좋은 날 다시 재보면 값이 달라질 수 있어요.',
      },
      // 목소리 피로도(시안 `921:5549`) — 축 넷의 이름만 시안에서 가져왔다. 값은 엔진에
      // 없어 전부 `측정 준비 중`이다(숫자를 지어내지 않는다).
      fatigue: {
        radarLabel: '목소리 피로도 축 넷의 레이더 차트',
        section: '목소리 피로도',
        note: '지속적으로 사용했을 때 목소리가 쉽게 지치는 정도예요. 아직 재는 산식이 없어서 축만 세워 뒀어요.',
        axis: {
          best: {
            label: '최상',
            note: '높은 음역에서의 목소리 안정감',
          },
          normal: {
            label: '보통',
            note: '일반적인 대화 음역에서의 편안함',
          },
          hoarse: {
            label: '살짝 잠김',
            note: '목이 조이거나 답답함을 느끼는 정도',
          },
          bad: {
            // 설문의 네 선택지와 같은 이름을 쓴다(시안) — 설문을 바꾸면 여기도 같이.
            label: '많이 잠김',
            note: '음이 흔들리거나 불안정한 정도',
          },
        },
      },
      sustain: {
        section: '진단 1. 아~ 길게 부르기',
        breath: '호흡 지속력',
        seconds: '{{value}}초',
        band: {
          short: '같은 성별·연령대 평균(15~20초)보다 조금 짧아요',
          inBand: '같은 성별·연령대 평균(15~20초) 안에 들어요',
          long: '같은 성별·연령대 평균(15~20초)보다 길어요',
        },
        stability: '소리 안정성',
        clarity: '목소리 맑기',
        clarityLevel: {
          low: '숨소리가 섞인 편',
          mid: '보통',
          high: '맑은 편',
        },
        clarityNote: '숨소리 섞임이 적은 깨끗한 발성일수록 맑게 들려요.',
        resonance: '울림·공명',
        resonanceLevel: {
          low: '담백한 편',
          mid: '보통',
          high: '풍부한 편',
        },
        resonanceNote: '소리에 광택이 더해지면 전달력이 좋아져요.',
      },
      // 지표 상세 셸(시안 §8.2). 한 줄 해석은 **가장 낮은 값**을 지목한다 — 잘한 곳을
      // 칭찬하는 문장은 어느 회차에나 붙어서 다음에 뭘 할지를 못 정해 준다.
      tabs: {
        label: '지표 상세',
        footnote: '측정 환경과 컨디션에 따라 결과는 달라질 수 있어요.',
        name: {
          fatigue: '목소리 피로도',
          range: '음역',
          registers: '음정',
          vibrato: '바이브레이션',
          breath: '호흡 안정도',
          formant: '싱어즈 포먼트',
          resonance: '공명 구간',
        },
        // 상세 셸의 탭 머리 — 제목 아래 한 줄 부제(시안 §8.3~§8.9).
        subtitle: {
          fatigue: '지속적으로 사용했을 때 목소리가 쉽게 지치는 정도예요.',
          range: '내가 낼 수 있는 음의 범위',
          registers: '음역 구간마다 음정이 얼마나 고르게 유지되는지 봐요.',
          vibrato: '음높이의 규칙적인 떨림 — 속도·폭·규칙성을 봐요.',
          breath: '소리를 길게 유지하는 동안의 흔들림을 체크해요.',
          formant: '목소리의 공명(울림)이 얼마나 잘 형성되었는지 보여줘요.',
          resonance: '울림이 밝은 쪽인지, 넓게 퍼졌는지 모였는지를 봐요.',
        },
        // 점수 배지 세 칸(scoreLevel). 문턱은 미보정이다 — 색을 고르는 자리다.
        level: { high: '좋음', mid: '보통', low: '주의' },
        insightTitle: '한 줄 해석',
        keyPoints: '핵심 포인트',
        details: '항목별 설명',
        legend: { mine: '나의 결과', average: '평균' },
        insight: {
          registers: {
            lowExtension:
              '가장 낮은 음역이 이번엔 제일 흔들렸어요. 낮은 음은 천천히 내려가며 힘을 빼면 안정돼요.',
            modal:
              '평소 말하는 음역이 이번엔 제일 흔들렸어요. 편한 높이부터 다시 잡아 보면 좋아요.',
            passaggio:
              '중음에서 고음으로 넘어가는 자리가 제일 흔들렸어요. 이 구간은 누구나 어려운 곳이에요.',
            head: '높은 음역이 이번엔 제일 흔들렸어요. 무리해서 올리기보다 편한 높이를 넓혀 가는 게 빨라요.',
            highExtension:
              '가장 높은 음역이 이번엔 제일 흔들렸어요. 여긴 원래 가장자리라 조금씩 늘려도 충분해요.',
          },
          vibrato: {
            inBand: '떨림의 속도와 폭이 자연스러운 범위 안에 있어요.',
            slow: '떨림이 느린 편이에요. 천천히 흔들리는 만큼 소리가 무겁게 들릴 수 있어요.',
            fast: '떨림이 빠른 편이에요. 빠르게 흔들리면 소리가 조급하게 들릴 수 있어요.',
            narrow:
              '떨림의 폭이 좁은 편이에요. 음이 거의 흔들리지 않아 떨림으로 들리기 어려워요.',
            wide: '떨림의 폭이 넓은 편이에요. 크게 흔들리면 음이 어디인지 흐려질 수 있어요.',
          },
          breath: {
            start:
              '시작할 때 흔들림이 가장 컸어요. 첫 숨을 충분히 채우고 시작해 보세요.',
            middle: '중간 구간에서 호흡이 약해져 흔들림이 커졌어요.',
            late: '후반에 흔들림이 가장 컸어요. 숨이 떨어지는 지점이 거기예요.',
          },
          formant: {
            inBand: '울림이 적정 범위 안에 모여 있어요.',
            centerLow:
              '울림이 적정 범위보다 낮은 쪽에 모였어요. 소리가 두껍게 들릴 수 있어요.',
            centerHigh:
              '울림이 적정 범위보다 높은 쪽에 모였어요. 소리가 얇게 들릴 수 있어요.',
            levelLow:
              '울림이 약한 편이에요. 대역은 맞지만 그 자리에 실린 힘이 적어요.',
          },
          resonance: {
            concentrated:
              '울림이 한곳에 모여 있어요. 조금 더 넓은 울림을 쓰면 더 풍부하고 안정적인 공명을 만들 수 있어요.',
            wide: '울림이 넓게 퍼져 있어요. 풍부한 대신 초점이 흐려질 수 있어요.',
            dark: '어두운 쪽 울림이에요. 두껍고 부드럽게 들리는 소리예요.',
            bright:
              '밝은 쪽 울림이에요. 또렷하게 들리는 대신 얇아질 수 있어요.',
            balanced: '밝기도 넓이도 가운데쯤이에요.',
          },
        },
      },
      // 음정 구간 — 경계 음이름은 레코드가 들고 있는 값에서 온다. 여기 박지 않는다.
      registers: {
        intro: '음역을 다섯 구간으로 나눠 분석했어요',
        legendStability: '안정성 (0-100)',
        legendHistory: '자기 이력 대비 (%)',
        desc: {
          lowExtension: '프리아기사 음역',
          modal: '주된 구간',
          passaggio: '최대 발성',
          head: '상위 음',
          highExtension: '유효음역 밖',
        },
        spanShort: '{{low}}-{{high}} · {{desc}}',
        section: '음정 — 음역 구간별 안정성',
        // 시안 §8.5 머리의 도넛 라벨.
        accuracy: '음정 정확도',
        note: '음역을 다섯 구간으로 나눠, 구간마다 목소리가 얼마나 고르게 나왔는지 봐요. 이번에 부르지 않은 구간은 비워 둬요.',
        span: '{{low}} ~ {{high}} · 이력 대비 {{history}}',
        history: '{{value}}%',
        // 비교할 직전 회차가 없다(첫 회차이거나 그때 이 구간을 안 불렀다). 0%가 아니다.
        historyNone: '—',
        name: {
          lowExtension: '저역 확장',
          modal: '중성',
          passaggio: '전환 (passaggio)',
          head: '두성',
          highExtension: '고역 확장',
        },
      },
      // 호흡 안정도 — 구간 라벨의 초는 엔진 상수(BREATH_SEGMENTS)에서 온다. 여기 박지 않는다.
      breath: {
        legendScore: '호흡 안정도 점수',
        legendAverage: '평균 기준선',
        bySegment: '구간별 안정도',
        point: '{{value}}점',
        desc: {
          high: '안정적으로 유지했어요.',
          mid: '흔들림이 조금 있었어요.',
          low: '흔들림이 커졌어요.',
        },
        badge: { high: '안정적', mid: '보통', low: '주의' },
        // 라인 차트(시안 §8.7)의 축·대체 텍스트.
        chartLabel: '구간별 호흡 안정도 그래프',
        axisSec: '{{value}}초',
        axisScore: '세로축 {{min}}~{{max}}점',
        section: '호흡 안정도',
        row: '{{name}} ({{from}}~{{to}}초)',
        name: { start: '시작', middle: '중간', late: '후반' },
        note: '한 호흡 안에서 흔들림이 언제 있었는지를 봐요. 녹음이 짧아 닿지 않은 구간은 비워 둬요.',
      },
      // 싱어즈 포먼트 — 적정 범위 숫자는 resultCopy의 상수에서 온다. 여기 박지 않는다.
      formant: {
        tickHz: '{{value}}k',
        unitHz: 'Hz',
        unitDb: 'dB',
        section: '싱어즈 포먼트',
        note: '목소리의 공명(울림)이 어느 대역에 얼마나 세게 모였는지를 봐요.',
        center: '공명 중심 주파수',
        centerValue: '{{value, number}} Hz',
        centerRange: '적정 범위 {{min}}~{{max}}kHz',
        level: '공명 세기',
        levelValue: '{{value}} dB',
        levelRange: '적정 범위 {{min}} ~ {{max}}dB',
      },
      // 공명 구간 — 눈금이 미보정이라 배지는 "밝은 편"까지만 말하고 점수를 안 낸다(§8.9).
      resonance: {
        section: '공명 구간',
        note: '울림이 밝은 쪽인지 어두운 쪽인지, 넓게 퍼졌는지 모였는지를 봐요.',
        brightness: '목소리 밝기',
        brightnessAxis: '어두움 ↔ 밝음',
        spread: '울림의 넓이',
        spreadAxis: '넓음 ↔ 집중',
        axisValue: '{{axis}} · {{value, number}} Hz',
        // 다섯 칸(TestFlight #59) — `stepOfPosition`.
        brightnessLevel: {
          veryLow: '어두운 편',
          low: '조금 어두움',
          mid: '균형적',
          high: '조금 밝음',
          veryHigh: '밝은 편',
        },
        spreadLevel: {
          veryLow: '넓은 편',
          low: '조금 넓음',
          mid: '균형적',
          high: '조금 집중',
          veryHigh: '집중된 편',
        },
        style: '공명 스타일',
        styleNote: '지금의 공명 성향을 한눈에 보여줘요.',
        here: '현재 위치',
        axis: {
          top: '밝고 또렷함',
          bottom: '어둡고 풍부함',
          left: '넓은 울림 ←',
          right: '→ 집중된 울림',
        },
      },
      // 떨림 — 점수가 아니라 실측 세 값이다(시안 §8.6). 못 잰 값은 pending으로 떨어진다.
      vibrato: {
        axisSecShort: '{{value}}s',
        depthRef: '참고 구간 ±{{min}}-{{max}} cents',
        centsUnit: 'cents',
        rateRef: '참고 {{min}}-{{max}} Hz',
        depthRatio: '약 반음의 {{ratio}}배',
        regularityBasis: '주기 편차 기반',
        regularityScale: { low: '낮음', mid: '보통', high: '좋음' },
        explain: {
          title: '진동 폭 이해하기',
          body: '바이브레이션의 폭(cents)은 소리의 높낮이가 얼마나 흔들리는지 나타냅니다.',
          small: { title: '폭이 작을 때', desc: '떨림이 작고 담백한 소리' },
          good: { title: '적절한 폭', desc: '자연스럽고 풍부한 소리' },
          large: { title: '폭이 클 때', desc: '떨림이 커서 불안정한 소리' },
        },
        // 파형(시안 §8.6). **녹음의 그림이 아니라** 잰 두 값으로 그린 모식도다.
        chartLabel: '떨림 모식도 — 속도 {{rate}}Hz, 폭 {{depth}} cents',
        axisSec: '{{value}}초',
        axisCents: '±{{value}} cents',
        waveNote:
          '이 그림은 녹음의 파형이 아니라, 잰 속도와 폭으로 그린 모식도예요.',
        // 음정 곡선이 있는 회차 — 그 테이크에서 소리가 가장 많이 담긴 3초.
        chartLabelMeasured:
          '이 회차의 떨림 — 속도 {{rate}}Hz, 폭 {{depth}} cents',
        waveNoteMeasured:
          '이 회차에서 실제로 흔들린 모양이에요(3초). 음 전체가 천천히 흐른 건 빼고, 폭은 잰 값에 맞췄어요.',
        section: '떨림(바이브레이션)',
        rate: '속도',
        rateValue: '{{value}} Hz',
        rateNote: '자연스러운 떨림은 보통 {{min}}~{{max}}Hz예요.',
        depth: '폭',
        depthValue: '±{{value}} cents',
        depthNote: '한 반음의 {{ratio}}배만큼 흔들렸어요.',
        regularity: '규칙성',
        regularityValue: '{{value}} %',
        regularityNote: '떨림 주기가 얼마나 고른지를 봐요.',
      },
      range: {
        // 시안 §8.4 — 상단 카드와 요약 행.
        wholeTitle: '내 전체 음역',
        wholeDesc: '현재 내 목소리로 낼 수 있는 가장 낮은 음과 높은 음',
        lowest: '최저음',
        highest: '최고음',
        widest: '최대 음역',
        hz: '({{value}} Hz)',
        semitones: '({{value}}반음)',
        section: '진단 2. 저음/고음 내기',
        // 건반 막대(시안 §8.4)의 범례 — 칠한 곳과 안 칠한 곳이 각각 무엇인지.
        legendFilled: '낼 수 있는 음',
        legendEmpty: '내지 못한 음',
        mine: '내 음역대',
        notes: '{{low}} ~ {{high}}',
        span: {
          whole: '약 {{octaves}}옥타브',
          half: '약 {{octaves}}옥타브 반',
          halfOnly: '약 반 옥타브',
        },
        voiceType: '예상 보이스 타입',
        // 성부 이름은 단정하지 않는다 — 음역만 보고 고른 값이라 "계열"이다.
        types: {
          bass: '베이스 계열',
          baritone: '바리톤 계열',
          tenor: '테너 계열',
          contralto: '알토 계열',
          mezzo: '메조소프라노 계열',
          soprano: '소프라노 계열',
        },
        // 조사는 마지막 이름의 받침이 정한다 — "성시경과" / "아이유와"(hasFinalConsonant).
        similar: {
          gwa: '{{singers}}과 비슷한 음역대예요',
          wa: '{{singers}}와 비슷한 음역대예요',
        },
        // 가수 매핑은 실측이 아니라 인상 기반 추정이다 — 화면이 그렇게 말한다.
        similarNote: '대표 가수는 음역대만 견준 추정이에요.',
        // 대표 가수 이름 — en은 각자 활동에 쓰는 영문 표기를 따른다.
        singers: {
          choiBaekho: '최백호',
          kimKwangseok: '김광석',
          kimDongryul: '김동률',
          sungSikyung: '성시경',
          parkHyoshin: '박효신',
          kimBumsoo: '김범수',
          leeSora: '이소라',
          jangJaein: '장재인',
          iu: '아이유',
          taeyeon: '태연',
          parkJunghyun: '박정현',
          sohyang: '소향',
        },
        register: '고음 전환',
        registerTimes: '{{count}}회',
        registerNone: '고음으로 올라갈 때 소리가 끊기지 않았어요',
        registerCount:
          '고음으로 올라갈 때 소리가 {{count}}회 끊겼어요 — 성구 전환 연습이 필요해요',
        registerPending:
          '이번 회차에서는 고음 전환을 볼 만큼 올라간 구간이 없었어요',
      },
      song: {
        section: '진단 3. 노래 따라부르기',
        // 이 축과 이름이 겹치지 않게 "노래"를 붙인다 — 값의 근거가 서로 다르다.
        accuracy: '노래 음정 정확도',
        percent: '{{value}}%',
        hits: '{{total}}개 음 중 약 {{hit}}개를 정확히 맞췄어요',
        segments: '구간 분석',
        segment: {
          low: {
            onPitch: '저음 구간은 정확했어요',
            flat: '저음 구간에서 음이 살짝 낮아지는(플랫) 경향이 있어요',
            sharp: '저음 구간에서 음이 살짝 높아지는(샾) 경향이 있어요',
          },
          high: {
            onPitch: '고음 구간도 정확했어요',
            flat: '고음 구간에서 음이 살짝 낮아지는(플랫) 경향이 있어요',
            sharp: '고음 구간에서 음이 살짝 높아지는(샾) 경향이 있어요',
          },
          pending: '구간 경향을 말할 만큼 음을 부르지 않았어요',
        },
        timing: '박자',
        timingSteady: '박자는 안정적으로 따라갔어요',
        timingLate: '전반적으로 살짝 늦게 들어가는 편이었어요',
        timingEarly: '전반적으로 살짝 빨리 들어가는 편이었어요',
        timingPending: '박자를 판단할 만큼 음을 맞추지 못했어요',
        skipped: '이번 회차에서는 노래 따라부르기를 하지 않았어요',
      },
      summary: {
        section: '종합',
        total: '총점',
        uncalibrated: '총점은 측정된 축의 균등 평균이에요 (가중치 미보정)',
        axes: '총점을 이루는 축',
        type: '보컬 타입',
        // 조각을 이어 한 문장으로 — "맑고 안정적인 밸런스형".
        type1: '{{p1}}',
        type2: '{{p1}} {{p2}}',
        type3: '{{p1}} {{p2}} {{p3}}',
        typeParts: {
          tone: { low: '숨소리가 섞이고', mid: '부드럽고', high: '맑고' },
          stability: { low: '흔들리는', mid: '고른', high: '안정적인' },
          shape: {
            narrow: '집중형',
            balanced: '밸런스형',
            wide: '넓은 음역형',
            unknown: '스타일',
          },
        },
        strengths: '강점',
        improvements: '개선점',
        points: {
          sustain: {
            strong: '한 호흡이 길게 이어져요',
            weak: '호흡을 더 길게 끌면 표현이 편해져요',
          },
          stability: {
            strong: '소리가 흔들림 없이 고르게 유지돼요',
            weak: '소리를 뻗는 동안 음높이가 조금 흔들려요',
          },
          clarity: {
            strong: '숨소리가 적고 깨끗하게 울려요',
            weak: '숨소리가 섞여 소리가 흐려질 때가 있어요',
          },
          resonance: {
            strong: '소리에 광택이 있어 잘 전달돼요',
            weak: '울림을 더하면 소리가 멀리 나가요',
          },
          range: {
            strong: '쓸 수 있는 음역이 넓어요',
            weak: '음역을 조금씩 넓히면 고를 수 있는 곡이 늘어요',
          },
          register: {
            strong: '고음으로 올라갈 때 소리가 안 끊겨요',
            weak: '성구가 바뀌는 자리에서 소리가 끊겨요',
          },
          songAccuracy: {
            strong: '정답 멜로디를 정확하게 따라갔어요',
            weak: '정답 멜로디와 음이 벌어지는 구간이 있어요',
          },
          timing: {
            strong: '박자를 제때 맞춰 들어갔어요',
            weak: '음이 시작하는 자리가 조금씩 밀려요',
          },
        },
      },
      notify: {
        body: "{{nick}}님의 진단 결과에 맞는 '고음 전환 훈련'이 준비되면 앱 알림으로 알려드릴게요",
      },
      cta: '홈으로',
    },
  },
};
